module.exports = __webpack_public_path__ + "assets/img/ff78c8e9c8fd3fdc17b6a1a866ba3a4f.svg";